<mat-drawer-container
    [hasBackdrop]="true"
    [style.background-color]="'var(--background-color-primary)'"
>
    <mat-drawer
        [opened]="drawerOpen"
        position="end"
        #drawer
        (closed)="onDrawerClosed()"
    >
        @defer (when !loading) {
            <app-report-adjustments-sidenav
                [report]="report"
                [company]="company"
                [scenarios]="report.scenarios"
                [currentPage]="initialPageSidenav"
                style="height: 100%"
                (handleChangePeriod)="onChangePeriod($event)"
                (handleChangeComparation)="onChangeComparation($event)"
                (handleResetPeriod)="onResetPeriod()"
                (onOptionSelected)="onOptionSelected($event)"
                (onClose)="onDrawerClosed()"
                (handleChangeAnalysis)="onChangeAnalysis($event)"
                (handleResetAnalysis)="onResetAnalysis()"
                [optionsNavigation]="{
                    period: true,
                    comparation: true,
                    analysisplus: company?.isGroup ? false : true
                }"
            ></app-report-adjustments-sidenav>
        }
    </mat-drawer>
    <mat-drawer-content id="ReportContentMobileScroll">
        <div id="ReportDashboardMobile" fxLayout="column" fxFlex>
            <app-report-header
                [options]="report?.options"
                [company]="company"
                [reportName]="report?.props?.name"
            ></app-report-header>
            <div
                style="position: sticky; top: 0; z-index: 1000"
                [style.background-color]="'var(--background-color-primary)'"
            >
                <app-report-toolbar
                    [options]="report?.options"
                    [company]="company"
                    [loading]="loading"
                    (handleResetPeriod)="onResetPeriod()"
                ></app-report-toolbar>
            </div>
            <div
                fxLayout="row"
                class="gap-16"
                style="
                    padding: 0px var(--spacing-12) var(--spacing-24);
                    padding-top: 0px;
                "
                [style.background-color]="'var(--background-color-primary)'"
            >
                @if (selectedAnalysisType?.projection) {
                    <dsn-button
                        [label]="'Projeção'"
                        [type]="'secondary-light'"
                        [size]="'small'"
                        [disabled]="loading"
                        [iconRight]="'fa-solid fa-xmark'"
                        [iconLeftCustom]="
                            '/images/icons/analyze-plus-stars.svg'
                        "
                        [active]="false"
                        [fontWeight]="'bold'"
                        [typeButton]="'button'"
                        (onClick)="onClearAnalysis('projection')"
                    ></dsn-button>
                }

                @if (selectedAnalysisType?.goals) {
                    <dsn-button
                        [label]="'Objetivo'"
                        [type]="'secondary-light'"
                        [size]="'small'"
                        [disabled]="loading"
                        [iconRight]="'fa-solid fa-xmark'"
                        [iconLeftCustom]="
                            '/images/icons/analyze-plus-stars.svg'
                        "
                        [active]="false"
                        [fontWeight]="'bold'"
                        [typeButton]="'button'"
                        (onClick)="onClearAnalysis('goals')"
                    ></dsn-button>
                }

                @if (selectedAnalysisType?.budget) {
                    <dsn-button
                        [label]="'Orçamento'"
                        [type]="'secondary-light'"
                        [size]="'small'"
                        [disabled]="loading"
                        [iconRight]="'fa-solid fa-xmark'"
                        [iconLeftCustom]="
                            '/images/icons/analyze-plus-stars.svg'
                        "
                        [active]="false"
                        [fontWeight]="'bold'"
                        [typeButton]="'button'"
                        (onClick)="onClearAnalysis('budget')"
                    ></dsn-button>
                }
            </div>
            <div
                fxLayout="column"
                style="padding: var(--spacing-12); gap: var(--spacing-16)"
                [style.marginBottom]="'84px'"
            >
                @if (!company?.isGroup && preferenceService.viewBench) {
                    <dsn-expand-collapse
                        id="SectionBenchmarking"
                        [isExpanded]="sectionStates['SectionBenchmarking']"
                        [customIcon]="'images/icons/benchmarking-icon.svg'"
                        [label]="'Benchmarking'"
                        [type]="'default'"
                        [style.display]="hasBenchmarking ? 'block' : 'none'"
                        [fontSize]="'medium'"
                    >
                        <app-report-beachmarking-section
                            [report]="report"
                            [company]="company"
                            [loading]="loading"
                            [previewMode]="previewMode"
                            (handleBenchmarkingDataLoaded)="
                                onBenchmarkingDataLoaded($event)
                            "
                        ></app-report-beachmarking-section>
                    </dsn-expand-collapse>
                }

                @if (preferenceService.viewPeformance) {
                    <dsn-expand-collapse
                        id="SectionPerformance"
                        [isExpanded]="sectionStates['SectionPerformance']"
                        [customIcon]="'images/icons/performance-icon.svg'"
                        [label]="'Performance'"
                        [type]="'default'"
                        [fontSize]="'medium'"
                    >
                        @if (!loading) {
                            <app-report-performance
                                [report]="report"
                                [visualizations]="report.visualizations"
                                [options]="report.options"
                                [company]="company"
                                [previewMode]="previewMode"
                            ></app-report-performance>
                        } @else {
                            <div fxLayout="column" class="padding-12 gap-12">
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="center center"
                                    class="gap-12"
                                >
                                    <dsn-skeleton-loader
                                        [type]="'circle'"
                                        [width]="'80px'"
                                        [height]="'80px'"
                                    ></dsn-skeleton-loader>
                                    <div fxLayout="column" class="gap-4">
                                        @for (
                                            item of [1, 2, 3, 4];
                                            track item
                                        ) {
                                            <dsn-skeleton-loader
                                                [type]="'rectangle'"
                                                [width]="'100px'"
                                                [height]="'14px'"
                                            ></dsn-skeleton-loader>
                                        }
                                    </div>
                                </div>
                                <dsn-skeleton-loader
                                    [type]="'rectangle'"
                                    [width]="'200px'"
                                    [height]="'20px'"
                                ></dsn-skeleton-loader>
                                <div fxLayout="row" class="gap-12">
                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'100px'"
                                        [height]="'34px'"
                                    ></dsn-skeleton-loader>
                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'100px'"
                                        [height]="'34px'"
                                    ></dsn-skeleton-loader>
                                </div>
                                <dsn-skeleton-loader
                                    [type]="'rectangle'"
                                    [width]="'100%'"
                                    [height]="'38px'"
                                ></dsn-skeleton-loader>
                                <dsn-skeleton-loader
                                    [type]="'rectangle'"
                                    [width]="'100%'"
                                    [height]="'38px'"
                                ></dsn-skeleton-loader>
                            </div>
                        }
                    </dsn-expand-collapse>
                }

                <!-- <dsn-expand-collapse
                    id="SectionNavigationTips"
                    [isExpanded]="sectionStates['SectionNavigationTips']"
                    [icon]="'fa-solid fa-lightbulb'"
                    [label]="'Dicas de Navegação'"
                    [type]="'info'"
                    [fontSize]="'medium'"
                >
                    <app-app-report-hints-navigation></app-app-report-hints-navigation>
                </dsn-expand-collapse> -->

                <dsn-expand-collapse
                    id="SectionIndicators"
                    [isExpanded]="sectionStates['SectionIndicators']"
                    [customIcon]="'images/icons/indicators-icon.svg'"
                    label="Indicadores"
                    type="transparent"
                    [fontSize]="'medium'"
                >
                    @if (report?.visualizations?.visualzations?.length) {
                        <div
                            fxLayout="column"
                            style="padding: var(--spacing-16) 0"
                            class="gap-16"
                        >
                            <dsn-custom-select
                                [options]="orderOptions"
                                [selectedValue]="selectedOrder"
                                (selectionChange)="onOrderChange($event)"
                            >
                                <dsn-button
                                    iconLeft="fa-solid fa-exchange-alt fa-rotate-90"
                                    iconRight="fas fa-caret-down"
                                    [label]="selectedOrder"
                                    type="tertiary"
                                    prelabel="Ordenar por:"
                                    [active]="true"
                                    width="full"
                                    justify="start"
                                    size="large"
                                ></dsn-button>
                            </dsn-custom-select>
                            @if (!loading) {
                                @for (
                                    visualization of sortedVisualizations;
                                    track visualization.props._id
                                ) {
                                    <app-report-visualization
                                        [loading]="loading"
                                        [id]="
                                            'visualization-' +
                                            visualization.props._id
                                        "
                                        [visualization]="visualization"
                                        [company]="company"
                                        [report]="report"
                                        [previewMode]="previewMode"
                                        class="report-visualization"
                                    ></app-report-visualization>
                                }
                            } @else {
                                <div
                                    fxLayout="column"
                                    style="
                                        gap: var(--spacing-8);
                                        padding: var(--spacing-12);
                                        border: var(--border-width-1) solid
                                            var(--color-border-light);
                                        border-radius: var(--border-radius-8);
                                    "
                                >
                                    <div fxLayout="row">
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'146px'"
                                            [height]="'14px'"
                                        ></dsn-skeleton-loader>
                                        <span fxFlex></span>
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'126px'"
                                            [height]="'14px'"
                                        ></dsn-skeleton-loader>
                                    </div>

                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'126px'"
                                        [height]="'12px'"
                                        style="margin-top: var(--spacing-8)"
                                    ></dsn-skeleton-loader>

                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'106px'"
                                        [height]="'28px'"
                                    ></dsn-skeleton-loader>

                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'36px'"
                                        [height]="'12px'"
                                    ></dsn-skeleton-loader>
                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'100%'"
                                        [height]="'400px'"
                                        style="margin-top: var(--spacing-16)"
                                    ></dsn-skeleton-loader>
                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'100%'"
                                        [height]="'40px'"
                                        style="margin-top: var(--spacing-16)"
                                    ></dsn-skeleton-loader>
                                    <dsn-skeleton-loader
                                        [type]="'rectangle'"
                                        [width]="'100%'"
                                        [height]="'40px'"
                                        style="margin-top: var(--spacing-8)"
                                    ></dsn-skeleton-loader>
                                </div>
                            }
                        </div>
                    }
                </dsn-expand-collapse>
                @if (!previewMode && contact?.props?._id !== "convidadoId") {
                    <dsn-expand-collapse
                        id="SectionFeedback"
                        [isExpanded]="sectionStates['SectionFeedback']"
                        [icon]="'fa-regular fa-message'"
                        [label]="'Feedback'"
                        [type]="'default'"
                    >
                        <app-report-feedback-form
                            [report]="report"
                        ></app-report-feedback-form>
                    </dsn-expand-collapse>
                }
            </div>
        </div>
        @defer (when !loading) {
            @if (!previewMode) {
                <div
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    style="
                        width: 100%;
                        position: fixed;
                        bottom: 16px;
                        padding: 0px 24px;
                        z-index: 1000;
                    "
                >
                    <app-menu-bottom-mobile
                        [isShowNanda]="
                            contact?.props?._id !== 'convidadoId' &&
                            contact?.props?._id !== undefined &&
                            contact?.props?._id !== null
                        "
                        [style]="
                            contact?.props?._id !== 'convidadoId'
                                ? 'width: 100%'
                                : ''
                        "
                        [report]="report"
                        [company]="company"
                        (onOptionSelected)="onOptionSelected($event)"
                    ></app-menu-bottom-mobile>
                </div>
            }
        } @placeholder {}
    </mat-drawer-content>
</mat-drawer-container>
